import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { BunkBranch } from '@C/Director/Bunks/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      <Route path="/bunk/bunk-branch" component={BunkBranch} />
      <Route path="/bunk/bunk-branch/*">
        <Redirect to={`/bunk/bunk-branch`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
